import { FC, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
// Hooks
import useToggle from 'app/hooks/useToggle';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { deleteCurrentUser } from 'app/store/Users/Users.async';
// Selectors
import { selectLoading, selectMyUser } from 'app/store/Users/Users.selectors';
import { selectCurrentAccount } from 'app/store/Accounts/Accounts.selectors';
// Components
import { Button } from 'app/components/Mui';
import ConfirmationDialog from 'app/dialogs/ConfirmationDialog';
// i18next
import { useTranslation } from 'react-i18next';

const DeleteAccountButton:FC = () => {
  const { t } = useTranslation();

  const myUser = useAppSelector(selectMyUser);
  const currentAccount = useAppSelector(selectCurrentAccount);

  const history = useHistory();

  const dispatch = useAppDispatch();

  const loading = useAppSelector(selectLoading);

  const {open, toggle } = useToggle();

  const deleteAccount = () => {
    dispatch(deleteCurrentUser({})).unwrap()
      .then(() => history.push('/account-deleted'));
  }

  if (!myUser || !currentAccount) return null;
  if (myUser.id !== currentAccount.ownerId) return null;
  return (
    <Fragment>
      <Button
        name="Delete account"
        color="error"
        fullWidth
        sx={{ mt: 4 }}
        onClick={toggle}
      >{t('pages.companyAccount.deleteAccountButton')}</Button>

      {open ? (
        <ConfirmationDialog
          open={open}
          onClose={toggle}
          loading={loading}
          title={t('dialogs.confirmation.deleteTitle', { dataType: t('labels.companyAccount') })}
          content={t('dialogs.confirmation.deleteConfirmation', { dataType: t('labels.companyAccount') })}
          onConfirm={deleteAccount}
        />
      ) : null}
    </Fragment>
  )
}

export default DeleteAccountButton;
